// export const API_URL = "http://localhost:8800/api"; // Replace this with your API URL
export const API_URL = "https://flighttrix.onrender.com/api";
